import { __extends } from "tslib";
import { UpdateChannelMessageRequest, UpdateChannelMessageResponse } from "../models/models_0";
import { deserializeAws_restJson1UpdateChannelMessageCommand, serializeAws_restJson1UpdateChannelMessageCommand, } from "../protocols/Aws_restJson1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
/**
 * <p>Updates the content of a message.</p>
 *
 *          <note>
 *             <p>The <code>x-amz-chime-bearer</code> request header is mandatory. Use the
 *                <code>AppInstanceUserArn</code> of the user that makes the API call as the value in
 *             the header.</p>
 *          </note>
 * @example
 * Use a bare-bones client and the command you need to make an API call.
 * ```javascript
 * import { ChimeSDKMessagingClient, UpdateChannelMessageCommand } from "@aws-sdk/client-chime-sdk-messaging"; // ES Modules import
 * // const { ChimeSDKMessagingClient, UpdateChannelMessageCommand } = require("@aws-sdk/client-chime-sdk-messaging"); // CommonJS import
 * const client = new ChimeSDKMessagingClient(config);
 * const command = new UpdateChannelMessageCommand(input);
 * const response = await client.send(command);
 * ```
 *
 * @see {@link UpdateChannelMessageCommandInput} for command's `input` shape.
 * @see {@link UpdateChannelMessageCommandOutput} for command's `response` shape.
 * @see {@link ChimeSDKMessagingClientResolvedConfig | config} for command's `input` shape.
 *
 */
var UpdateChannelMessageCommand = /** @class */ (function (_super) {
    __extends(UpdateChannelMessageCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function UpdateChannelMessageCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    /**
     * @internal
     */
    UpdateChannelMessageCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "ChimeSDKMessagingClient";
        var commandName = "UpdateChannelMessageCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: UpdateChannelMessageRequest.filterSensitiveLog,
            outputFilterSensitiveLog: UpdateChannelMessageResponse.filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    UpdateChannelMessageCommand.prototype.serialize = function (input, context) {
        return serializeAws_restJson1UpdateChannelMessageCommand(input, context);
    };
    UpdateChannelMessageCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restJson1UpdateChannelMessageCommand(output, context);
    };
    return UpdateChannelMessageCommand;
}($Command));
export { UpdateChannelMessageCommand };
//# sourceMappingURL=UpdateChannelMessageCommand.js.map